import 'react-datepicker/dist/react-datepicker.css'

import React, { forwardRef } from 'react'
import ReactDatePicker from 'react-datepicker'

import {
  DATEPICKER_DATE_FORMAT,
  DATE_FORMAT_CALENDAR,
} from '@/constants/global'

import { CustomHeader } from './components/CustomHeader'
import * as S from './styles'

import type { DatepickerDecoupledProps } from './types'

/**
 * DatePicker component based on {@link https://github.com/Hacker0x01/react-datepicker react-datepicker}
 * @component
 */

export const DatePicker = forwardRef<ReactDatePicker, DatepickerDecoupledProps>(
  (
    {
      monthsShown = 2,
      readOnly,
      children,
      dataCy,
      error,
      isWrapperSmall,
      className,
      customDateFormat,
      hideIcon = false,
      ...restProps
    },
    ref
  ) => (
    <S.Wrapper
      $error={error}
      data-cy={dataCy}
      $isWrapperSmall={isWrapperSmall}
      className={className}
      $isSingleMonth={monthsShown === 1}
      $isIconHidden={hideIcon}
    >
      <ReactDatePicker
        ref={ref}
        dateFormatCalendar={DATE_FORMAT_CALENDAR}
        dateFormat={customDateFormat || DATEPICKER_DATE_FORMAT}
        monthsShown={monthsShown}
        renderCustomHeader={({ ...props }) => (
          <CustomHeader monthsShown={monthsShown} {...props} />
        )}
        open={readOnly ? false : undefined}
        readOnly={readOnly}
        {...restProps}
      >
        {children}
      </ReactDatePicker>
    </S.Wrapper>
  )
)

DatePicker.displayName = 'DatepickerDecoupled'
